import React from "react";

const WarrantyMotorsportsTable = () => {
    // ["Category", "Supreme", "Elite", "ProGuard"],
    const data = [
        ["Jet Ski / PWC Covers", "$50.00", "$45.00", "$40.00"],
        ["Motorcycle Covers", "$30.00", "$25.00", "$20.00"],
        ["Scooter Covers", "$30.00", "$25.00", "$20.00"],
        ["ATV Covers", "$55.00", "$50.00", null],
        ["UTV Covers", "$60.00", "$55.00", null],
        ["Snowmobile Covers", "$55.00", "$50.00", "$45.00"],
    ];
    const images = [
        null,
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/4a93f6a9b7247710787b47c62083e1573ef80660.png?v=1766069783",
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/96ba6234e09a9935ea5abf9e551ba6f610f1e763.png?v=1766069783",
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/8b850f705bab7b5e4a95d353198af7053a7b0c47.png?v=1766069783",
    ]
    return (
        <div className="table-block table-block--warranty-vehicle table-block--warranty-motorsports">
            <div className="table-block">
                <div className="table-block__header">
                    <div className="table-block__header-cell table-block__header-cell--category">Category</div>
                    <div className="table-block__header-cell table-block__header-cell--supreme">Supreme</div>
                    <div className="table-block__header-cell table-block__header-cell--elite">Elite</div>
                    <div className="table-block__header-cell table-block__header-cell--proguard">ProGuard</div>
                </div>

                {data.map((row, index) => (
                    <div className="table-block__row" key={index}>
                        <div className="table-block__cell">{row[0]}</div>
                        <div className="table-block__cell">{row[1]}</div>
                        <div className="table-block__cell">{row[2]}</div>
                        <div className="table-block__cell">{row[3] || "---"}</div>
                    </div>
                ))}

                <div className="table-block__row">
                    {images.map((row, index) => (
                        <div className="table-block__cell table-block__cell--padding-none" key={index}>
                            {row ? <div className="table-block__warranty-badge-container"> <img className="table-block__warranty-badge" src={row} alt={row} /> </div   > : null}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default WarrantyMotorsportsTable;